module.exports = __webpack_public_path__ + "img/h5logo.63b0bc9d.png";